import { ACTION } from './../actions';
import store from 'store';
import { useCacheData } from '../../Shared/CacheData'
import { useSWCache } from '../../Shared/SWCache'
import { StoreKeys } from '../../project/Defines'

const defaultState = {
    isLoggedIn: !!store.get(StoreKeys.LoggedIn),
    popups: [],
    listStates: store.get(StoreKeys.ListStates) || {},
    // appToken: store.get(StoreKeys.AppToken),
    userToken: store.get(StoreKeys.UserToken),
    sessionId: store.get(StoreKeys.SessionId),
    culture: store.get(StoreKeys.Culture),
    role: store.get(StoreKeys.Role),
    networkCode: store.get(StoreKeys.NetworkCode),
    userData: store.get(StoreKeys.UserData),
    oldToken: store.get(StoreKeys.OldToken),
    enableServiceContract: !!store.get(StoreKeys.EnableServiceContract),
    dataMaintenance: store.get(StoreKeys.DataMaintenance),
    loaders: [],
    isMaintenanceModeEnabled: true,
    maintenanceModeStart: new Date('Jan 20 2022 08:40:00 GMT+0100'),
    maintenanceModeEnd: new Date('Jan 20 2022 08:50:00 GMT+0100'),
    portalUrl: store.get(StoreKeys.PortalUrl)
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case ACTION.LOGIN:
            store.set(StoreKeys.ExpireTime, (new Date()).setMinutes((new Date()).getMinutes() + 1));
            store.set(StoreKeys.UserToken, action.payload.userToken);
            store.set(StoreKeys.SessionId, action.payload.sessionId);
            store.set(StoreKeys.LoggedIn, true);
            store.set(StoreKeys.UserData, action.payload.userData);
            store.set(StoreKeys.Culture, action.payload.culture);
            store.set(StoreKeys.Role, action.payload.role);
            store.set(StoreKeys.NetworkCode, action.payload.networkCode);
            store.set(StoreKeys.EnableServiceContract, action.payload.enableServiceContract);
            store.set(StoreKeys.DataMaintenance, action.payload.dataMaintenance);
            store.set(StoreKeys.OldToken, action.payload.oldToken);
            store.set(StoreKeys.PortalUrl, action.payload.portalUrl);

            return {
                ...state,
                isLoggedIn: true,
                userToken: store.get(StoreKeys.UserToken),
                sessionId: store.get(StoreKeys.SessionId),
                role: store.get(StoreKeys.Role),
                networkCode: store.get(StoreKeys.NetworkCode),
                userData: store.get(StoreKeys.UserData),
                enableServiceContract: !!store.get(StoreKeys.EnableServiceContract),
                dataMaintenance: store.get(StoreKeys.DataMaintenance),
                oldToken: store.get(StoreKeys.OldToken),
                portalUrl: store.get(StoreKeys.PortalUrl)
            };

        case ACTION.LOGOUT:
            store.remove(StoreKeys.UserToken);
            store.remove("userToken");
            store.remove(StoreKeys.SessionId);
            store.remove(StoreKeys.Role);
            store.remove(StoreKeys.NetworkCode);
            store.remove(StoreKeys.UserData)
            store.remove(StoreKeys.LoggedIn);

            useCacheData.clearOnLogout();
            useSWCache.clearOnLogout();
            return {
                ...state,
                isLoggedIn: false,
                userToken: '',
                sessionId: null,
                userName: null,
                networkCode: null,
                role: null
            };

        // case ACTION.CHANGE_APPLICATION_TOKEN:
        //     if (action.data) {
        //         store.set(StoreKeys.AppToken, action.data);
        //         return {
        //             ...state,
        //             appToken: action.data
        //         };
        //     } else {
        //         store.remove(StoreKeys.AppToken);
        //         return {
        //             ...state,
        //             appToken: null
        //         };
        //     }

        case ACTION.CHANGE_USER_TOKEN:
            if (action.data) {
                store.set(StoreKeys.UserToken, action.data);
                return {
                    ...state,
                    userToken: action.data
                };
            } else {
                store.remove(StoreKeys.UserToken);
                return {
                    ...state,
                    userToken: null
                };
            }

        case ACTION.CHANGE_CULTURE:
            store.set(StoreKeys.Culture, action.data);
            return {
                ...state,
                culture: action.data
            };

        case ACTION.CHANGE_MAINTENANCE:
            store.set(StoreKeys.DataMaintenance, action.data);
            return {
                ...state,
                dataMaintenance: action.data
            };   

        case ACTION.OPEN_POPUP: {
            const popups = [...state.popups];
            popups.push(action.data);
            return {
                ...state,
                popups
            };
        }

        case ACTION.CLOSE_POPUP:
            {
                const popups = [...state.popups];
                const index = popups.findIndex(p => p.windowKey === action.windowKey);
                if (index >= 0) {
                    popups.splice(index, 1);
                }
                return {
                    ...state,
                    popups
                };
            }
        case ACTION.UPDATE_POPUP_TITLE:
            {
                const popups = [...state.popups];
                const index = popups.findIndex(p => p.windowKey === action.windowKey);
                if (index >= 0) {
                    popups[index].title = action.title;
                }
                return {
                    ...state,
                    popups
                };
            }

        case ACTION.CLOSE_ALL_POPUPS: {
            return {
                ...state,
                popups: []
            };
        }
        case ACTION.SET_LIST_STATE: {
            const ls = {
                ...state.listStates,
                [action.payload.listName]: action.payload.state
            };
            store.set(StoreKeys.ListStates, ls);
            return {
                ...state,
                listStates: ls
            };
        }
        case ACTION.CLEAR_LIST_STATES: {
            store.remove(StoreKeys.ListStates);
            return {
                ...state,
                listStates: {}
            };
        }

        case ACTION.STORAGE_CHANGE: {
            return {
                ...state,
                isLoggedIn: !!store.get(StoreKeys.LoggedIn),
                listStates: store.get(StoreKeys.ListStates) || {},
                userToken: store.get(StoreKeys.UserToken),
                culture: store.get(StoreKeys.Culture),
                role: store.get(StoreKeys.Role),
                networkCode: store.get(StoreKeys.NetworkCode),
                // networkName: store.get(StoreKeys.NetworkName),
                userName: store.get(StoreKeys.UserName),
                dataMaintenance: store.get(StoreKeys.DataMaintenance),
            };
        }

        case ACTION.ENABLE_SERVICE_CONTRACT_CHANGE: {
            store.set(StoreKeys.EnableServiceContract, action.payload?.enableServiceContract);
            return {
                ...state,
                enableServiceContract: !!action.payload?.enableServiceContract
            };
        }

        case ACTION.SET_LOADERS: {
            return {
                ...state,
                loaders: action.payload
            };
        }

        default:
            return state;
    }
}